import Validator from '../Validator';
import ValidatorInterface from '../ValidatorInterface';
import DataVariableInterface from "../../../DataVariables/ts/DataVariableInterface";

export default class ValidatorEmail extends Validator implements ValidatorInterface {

    private emails: Set<string>;
    private processedCount: number;
    private readonly mustBeUnique: boolean;

    /**
     * Constructor, determine if the email has to be unique
     *
     * @param dataVariable
     */

    public constructor(dataVariable: DataVariableInterface) {

        super(dataVariable);

        this.mustBeUnique = false;
        this.processedCount = 0;
        this.emails = new Set();

        if (dataVariable.uuid == '4b9KWeVNAB0cEG4evmUpUT') {
            this.mustBeUnique = true;
        }
    }

    /**
     * Check value for validity
     *
     * @param value
     * @param index
     * @param offset
     */

    public check(value: string, index: number, offset: number): boolean {

        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}$/igm.test(value)) {
            this.addError("invalid email address",index,value);
            return false;
        }

        if (this.mustBeUnique) {

            this.emails.add(value);
            this.processedCount++;

            if (this.emails.size !== this.processedCount) {
                this.processedCount--;
                this.addError("duplicate email address",index,value);
                return false;
            }
        }

        return true;
    }
}